var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBypassSystemSecurityControls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5540_88321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7629 25.1034H29.1867V23.9509C29.1867 22.3604 27.8959 21.0696 26.3054 21.0696C24.7149 21.0696 23.4241 22.3604 23.4241 23.9509V25.1034H22.8478C22.2139 25.1034 21.6953 25.622 21.6953 26.2559V32.0185C21.6953 32.6524 22.2139 33.171 22.8478 33.171H29.7629C30.3968 33.171 30.9155 32.6524 30.9155 32.0185V26.2559C30.9155 25.622 30.3968 25.1034 29.7629 25.1034ZM26.3054 30.2897C25.6715 30.2897 25.1529 29.7711 25.1529 29.1372C25.1529 28.5033 25.6715 27.9847 26.3054 27.9847C26.9393 27.9847 27.4579 28.5033 27.4579 29.1372C27.4579 29.7711 26.9393 30.2897 26.3054 30.2897ZM24.5766 25.1034V23.9509C24.5766 22.9943 25.3488 22.2221 26.3054 22.2221C27.262 22.2221 28.0342 22.9943 28.0342 23.9509V25.1034H24.5766Z",
    fill: "#141414"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3894 30.1871L34.3904 30.6496C34.3904 26.2561 34.1674 16.5161 26.2931 16.5408C18.2246 16.5408 18.2246 26.2251 18.2246 30.6496L18.2249 30.1871",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.30541,
    strokeDasharray: "1 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6941 31.1011C37.9703 31.1006 38.1938 30.8764 38.1934 30.6003C38.1929 30.3241 37.9687 30.1006 37.6926 30.1011L37.6941 31.1011ZM37.6926 30.1011L33.6223 30.1074L33.6238 31.1074L37.6941 31.1011L37.6926 30.1011Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9172 31.104C14.641 31.1036 14.4175 30.8794 14.418 30.6032C14.4184 30.3271 14.6426 30.1036 14.9188 30.104L14.9172 31.104ZM14.9188 30.104L18.9891 30.1104L18.9875 31.1104L14.9172 31.104L14.9188 30.104Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3172 29.1082L14.8467 30.1926C14.5771 30.3914 14.5755 30.794 14.8435 30.995L16.3174 32.1002",
    stroke: "#141414",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5540_88321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12.8571,
    fill: "white",
    transform: "translate(21.3057 20.6021)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBypassSystemSecurityControls);
export default __webpack_public_path__ + "static/media/bypass_system_security_controls.05739304d7e28c4e98a07c30d391c23e.svg";
export { ForwardRef as ReactComponent };